export default {
  badge: 'Infopiste',
  open: 'Avaa',
  close: 'Sulje',
  dismiss: 'Hylkää',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Peruuta',
  },
  dataIterator: {
    noResultsText: 'Ei osumia',
    loadingText: 'Ladataan kohteita...',
  },
  dataTable: {
    itemsPerPageText: 'Rivejä sivulla:',
    ariaLabel: {
      sortDescending: ': Järjestetty laskevasti. Poista järjestäminen aktivoimalla.',
      sortAscending: ': Järjestetty nousevasti. Järjestä laskevasti aktivoimalla.',
      sortNone: ': Ei järjestetty. Järjestä nousevasti aktivoimalla.',
      activateNone: 'Aktivoi lajittelun poistamiseksi.',
      activateDescending: 'Aktivoi laskevien laskevien lajittelemiseksi.',
      activateAscending: 'Aktivoi lajitella nouseva.',
      selectRow: 'Valitse rivi',
      selectAll: 'Valitse kaikki',
      selectGroup: 'Valitse ryhmä',
    },
    sortBy: 'Järjestä',
  },
  dataFooter: {
    itemsPerPageText: 'Kohteita sivulla:',
    itemsPerPageAll: 'Kaikki',
    nextPage: 'Seuraava sivu',
    prevPage: 'Edellinen sivu',
    firstPage: 'Ensimmäinen sivu',
    lastPage: 'Viimeinen sivu',
    pageText: '{0}-{1} ({2})',
  },
  dateRangeInput: {
    divider: '–',
  },
  monthPicker: {
    title: 'Valitse kuukausi',
    itemsSelected: '{0} valittu',
    header: 'Syötä kuukausi',
    range: {
      title: 'Syötä kuukaudet',
    },
    ariaLabel: {
      previousYear: 'Edellinen vuosi',
      nextYear: 'Seuraava vuosi',
      selectYear: 'Valitse vuosi',
      currentMonth: 'Nykyinen kuukausi, {0}',
    },
  },
  datePicker: {
    itemsSelected: '{0} valittu',
    range: {
      title: 'Valitse päivämäärät',
      header: 'Syötä päivämäärät',
    },
    title: 'Valitse päivämäärä',
    header: 'Syötä päivämäärä',
    input: {
      placeholder: 'Syötä päivämäärä',
    },
    ariaLabel: {
      previousMonth: 'Edellinen kuukausi',
      nextMonth: 'Seuraava kuukausi',
      selectYear: 'Valitse vuosi',
      previousYear: 'Edellinen vuosi',
      nextYear: 'Seuraava vuosi',
      selectMonth: 'Valitse kuukausi',
      selectDate: '{0}',
      currentDate: 'Tänään, {0}',
    },
  },
  noDataText: 'Ei dataa',
  carousel: {
    prev: 'Edellinen kuva',
    next: 'Seuraava kuva',
    ariaLabel: {
      delimiter: 'Karusellin kuva {0}/{1}',
    },
  },
  calendar: {
    moreEvents: '{0} lisää',
    today: 'Tänään',
  },
  heatmap: {
    less: 'Vähemmän',
    more: 'Enemmän',
  },
  input: {
    clear: 'Tyhjennä {0}',
    prependAction: '{0} edeltävä toiminto',
    appendAction: '{0} lisätty toiminto',
    otp: 'Syötä OTP-merkki {0}',
  },
  fileInput: {
    counter: '{0} tiedostoa',
    counterSize: '{0} tiedostoa ({1} yhteensä)',
  },
  fileUpload: {
    title: 'Vedä ja pudota tiedostot tähän',
    divider: 'tai',
    browse: 'Selaa tiedostoja',
  },
  timePicker: {
    am: 'ap.',
    pm: 'ip.',
    title: 'Valitse aika',
    hour: 'Tunti',
    minute: 'Minuutit',
    second: 'Sekunnit',
    notAllowed: 'Arvo ei ole sallittu',
  },
  pagination: {
    ariaLabel: {
      root: 'Sivutuksen navigointi',
      next: 'Seuraava sivu',
      previous: 'Edellinen sivu',
      page: 'Mene sivulle {0}',
      currentPage: 'Nykyinen sivu, Sivu {0}',
      first: 'Ensimmäinen sivu',
      last: 'Viimeinen sivu',
    },
  },
  stepper: {
    next: 'Seuraava',
    prev: 'Edellinen',
  },
  rating: {
    ariaLabel: {
      item: 'Luokitus {0}/{1}',
    },
  },
  loading: 'Ladataan...',
  infiniteScroll: {
    loadMore: 'Lataa lisää',
    empty: 'Ei enempää',
  },
  rules: {
    required: 'Tämä kenttä on pakollinen',
    email: 'Anna kelvollinen sähköpostiosoite',
    number: 'Tämä kenttä voi sisältää vain numeroita',
    integer: 'Tämä kenttä voi sisältää vain kokonaislukuja',
    capital: 'Tämä kenttä voi sisältää vain isoja kirjaimia',
    maxLength: 'Sinun tulee syöttää enintään {0} merkkiä',
    minLength: 'Sinun tulee syöttää vähintään {0} merkkiä',
    strictLength: 'Syötetyn kentän pituus on virheellinen',
    exclude: 'Merkki {0} ei ole sallittu',
    notEmpty: 'Valitse ainakin yksi arvo',
    pattern: 'Virheellinen muoto',
  },
  command: {
    search: 'Kirjoita komento tai hae...',
  },
  hotkey: {
    then: 'sitten',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Nuoli ylös',
    downArrow: 'Nuoli alas',
    leftArrow: 'Nuoli vasemmalle',
    rightArrow: 'Nuoli oikealle',
    backspace: 'Askelpalautin',
    space: 'Välilyönti',
    plus: 'plus',
    shortcut: 'Näppäinyhdistelmä: {0}',
    or: 'tai',
  },
  video: {
    play: 'Toista',
    pause: 'Tauko',
    seek: 'Hae',
    volume: 'Äänenvoimakkuus',
    showVolume: 'Näytä äänenvoimakkuuden säädin',
    mute: 'Mykistä',
    unmute: 'Poista mykistys',
    enterFullscreen: 'Koko näyttö',
    exitFullscreen: 'Poistu koko näytöstä',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Valitse väri näytöltä',
      hueSlider: 'Sävy',
      alphaSlider: 'Alfa',
      redInput: 'Punainen',
      greenInput: 'Vihreä',
      blueInput: 'Sininen',
      alphaInput: 'Alfa',
      hueInput: 'Sävy',
      saturationInput: 'Kylläisyys',
      lightnessInput: 'Vaaleus',
      hexInput: 'HEX-arvo',
      hexaInput: 'HEX alfa-arvolla',
      changeFormat: 'Vaihda värimuotoa',
    },
  },
}
